'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackUserInteraction = trackUserInteraction;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var _getUserInteractedWithWidget = require('../selectors/getUserInteractedWithWidget');

function trackUserInteraction() {
  return function (dispatch, getState) {
    if (!(0, _getUserInteractedWithWidget.getUserInteractedWithWidget)(getState())) {
      if (window.newrelic && window.newrelic.addPageAction && window.newrelic.setCustomAttribute) {
        window.newrelic.addPageAction('userInteractedWithWidget');
        window.newrelic.setCustomAttribute('interactedWithWidget', true);
      }
    }
    dispatch((0, _reduxActions.createAction)(_VisitorActionTypes.TRACK_USER_INTERACTION)());
  };
}